import React from "react";
import { Segment, Divider, Table } from "semantic-ui-react";

// https://stackoverflow.com/a/20463021
function fileSizeSI(a, b, c, d, e) {
  return (
    ((b = Math),
    (c = b.log),
    (d = 1e3),
    (e = (c(a) / c(d)) | 0),
    a / b.pow(d, e)).toFixed(2) +
    " " +
    (e ? "kMGTPEZY"[--e] + "B" : "Bytes")
  );
}

function downloadAll(files) {
  /**
   * Download a list of files.
   * @author speedplane
   * https://stackoverflow.com/a/29606450/1240268
   */
  function downloadNext(i) {
    if (i >= files.length) {
      // FIXME should we toast a message here?
    }
    var a = document.createElement("a");
    a.href = downloadLink(files[i]);
    a.target = "_parent";
    // Use a.download if available, it prevents plugins from opening.
    if ("download" in a) {
      a.download = files[i].filename;
    }
    // Add a to the doc for click to work.
    (document.body || document.documentElement).appendChild(a);
    if (a.click) {
      a.click(); // The click method is supported by most browsers.
    } else {
      // $(a).click() // Backup using jquery
    }
    // Delete the temporary link.
    a.parentNode.removeChild(a);
    // Download the next file with a small timeout. The timeout is necessary
    // for IE, which will otherwise only download the first file.
    setTimeout(function () {
      downloadNext(i + 1);
    }, 500);
  }
  // Initiate the first download.
  downloadNext(0);
}

// FIXME support download all button

// function download(file){
//   // https://stackoverflow.com/a/9834261
//   fetch('https://jsonplaceholder.typicode.com/todos/1')
//   .then(resp => resp.blob())
//   .then(blob => {
//     const url = window.URL.createObjectURL(blob);
//     const a = document.createElement('a');
//     a.style.display = 'none';
//     a.href = url;
//     // the filename you want
//     a.download = 'todo-1.json';
//     document.body.appendChild(a);
//     a.click();
//     window.URL.revokeObjectURL(url);
//     alert('your file has downloaded!'); // or you know, something with better UX...
//   })
//   .catch(() => alert('oh no!'));
// }

function downloadLink(file) {
  const region = file.filename.split("_").slice(0, 2).join("_");
  const qs = new URLSearchParams({
    date: file.date,
    region: region,
    type: file.collection,
    columnset: file.column_set,
  });
  return `/api/data?${qs}`;
}

function DashboardTable({ mobile, files }) {
  return (
    <>
      <Segment horizontal="true" className="ui container">
        <Table className="unstackable sortable">
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>Filename</Table.HeaderCell>
              <Table.HeaderCell>Size</Table.HeaderCell>
              <Table.HeaderCell>Download</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {files.map((f, i) => (
              <Table.Row key={f.filename}>
                <Table.Cell>{f.filename}</Table.Cell>
                <Table.Cell>{fileSizeSI(f.filesize)}</Table.Cell>
                <Table.Cell>
                  <a href={downloadLink(f)} download>
                    <i className="download icon"></i>
                  </a>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
        <Divider
          horizontal
          style={{ color: "#FFA26D", margin: "5em 0" }}
        ></Divider>
      </Segment>
      <p onClick={() => downloadAll(files)}>
        To download all the files listed click here.
      </p>
    </>
  );
}

export default DashboardTable;
